import { last } from "./node_gm_common"

export function isDev(): boolean {
    return process.env.NODE_ENV === "development"
}

export function isRu(): boolean {
    return last(location.hostname.split(".")) === "ru" || last(location.hostname.split(".")) === "xyz"
}

export const copyToClipboard = (str: string) => {
    const el = document.createElement("textarea")
    el.value = str
    el.setAttribute("readonly", "")
    el.style.position = "absolute"
    el.style.left = "-9999px"
    document.body.appendChild(el)
    let selected: Range|boolean = false
    const selection = document.getSelection()
    if (selection != null) {
        selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : false
    }
    el.select()
    document.execCommand("copy")
    document.body.removeChild(el)
    if (selected && selection) {
        selection.removeAllRanges()
        selection.addRange(selected)
    }
}
